/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentsMissingInvoicesRow } from "./ShipmentsMissingInvoicesRow";
import {
  ShipmentsMissingInvoicesRowFromJSON,
  ShipmentsMissingInvoicesRowFromJSONTyped,
  ShipmentsMissingInvoicesRowToJSON,
  ShipmentsMissingInvoicesRowToJSONTyped,
} from "./ShipmentsMissingInvoicesRow";

/**
 *
 * @export
 * @interface MissingInvoicesScreenRecords
 */
export interface MissingInvoicesScreenRecords {
  /**
   *
   * @type {Array<ShipmentsMissingInvoicesRow>}
   * @memberof MissingInvoicesScreenRecords
   */
  shipmentsWithoutInvoices: Array<ShipmentsMissingInvoicesRow>;
  /**
   *
   * @type {Array<ShipmentsMissingInvoicesRow>}
   * @memberof MissingInvoicesScreenRecords
   */
  shipmentsWithOverdueInvoices: Array<ShipmentsMissingInvoicesRow>;
}

/**
 * Check if a given object implements the MissingInvoicesScreenRecords interface.
 */
export function instanceOfMissingInvoicesScreenRecords(
  value: object,
): value is MissingInvoicesScreenRecords {
  if (
    !("shipmentsWithoutInvoices" in value) ||
    value["shipmentsWithoutInvoices"] === undefined
  )
    return false;
  if (
    !("shipmentsWithOverdueInvoices" in value) ||
    value["shipmentsWithOverdueInvoices"] === undefined
  )
    return false;
  return true;
}

export function MissingInvoicesScreenRecordsFromJSON(
  json: any,
): MissingInvoicesScreenRecords {
  return MissingInvoicesScreenRecordsFromJSONTyped(json, false);
}

export function MissingInvoicesScreenRecordsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MissingInvoicesScreenRecords {
  if (json == null) {
    return json;
  }
  return {
    shipmentsWithoutInvoices: (
      json["shipmentsWithoutInvoices"] as Array<any>
    ).map(ShipmentsMissingInvoicesRowFromJSON),
    shipmentsWithOverdueInvoices: (
      json["shipmentsWithOverdueInvoices"] as Array<any>
    ).map(ShipmentsMissingInvoicesRowFromJSON),
  };
}

export function MissingInvoicesScreenRecordsToJSON(
  json: any,
): MissingInvoicesScreenRecords {
  return MissingInvoicesScreenRecordsToJSONTyped(json, false);
}

export function MissingInvoicesScreenRecordsToJSONTyped(
  value?: MissingInvoicesScreenRecords | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentsWithoutInvoices: (
      value["shipmentsWithoutInvoices"] as Array<any>
    ).map(ShipmentsMissingInvoicesRowToJSON),
    shipmentsWithOverdueInvoices: (
      value["shipmentsWithOverdueInvoices"] as Array<any>
    ).map(ShipmentsMissingInvoicesRowToJSON),
  };
}
